import { add, type Duration } from 'date-fns';
import type { PeriodUnit, PlanFrequency } from '../api/models/bff';

const MONTHS_IN_YEAR = 12;
const PERIOD_UNITS: PeriodUnit[] = ['DAYS', 'MONTHS', 'YEARS'];

const FREQUENCY_DURATION: Record<PlanFrequency, Duration> = {
  DAILY: { days: 1 },
  WEEKLY: { weeks: 1 },
  MONTHLY: { months: 1 },
  BIMESTRIAL: { months: 2 },
  QUARTERLY: { months: 3 },
  ANNUAL: { years: 1 },
};

export function addBillingCycles(date: Date, frequency: PlanFrequency, cycles: number): Date {
  const duration = FREQUENCY_DURATION[frequency];
  const scaled = Object.fromEntries(Object.entries(duration).map(([unit, amount]) => [unit, amount * cycles]));

  return add(date, scaled);
}

export function getMonthsFromFrequency(frequency: PlanFrequency): number {
  const { months = 0, years = 0 } = FREQUENCY_DURATION[frequency];

  return months + years * MONTHS_IN_YEAR;
}

export function normalizeFrequency(value?: string): PlanFrequency | undefined {
  if (typeof value !== 'string') return undefined;
  const upper = value.toUpperCase();

  return upper in FREQUENCY_DURATION ? (upper as PlanFrequency) : undefined;
}

export function normalizePeriodUnit(value: unknown): PeriodUnit | undefined {
  if (typeof value !== 'string') return undefined;
  const upper = value.toUpperCase();

  return PERIOD_UNITS.find(unit => unit === upper);
}